import Http from './axios-config';

/** The superAdmin settings that take effect immediately (GET/PUT /admins/settings). */
class AppSettingsService {

    constructor() {
        this.http = new Http();
    }

    async getSettings() {
        return await this.http.get('/admins/settings');
    }

    /** The same settings, for a page that only mentions them: a failure shows no error toast. */
    async getSettingsQuietly() {
        return await this.http.get('/admins/settings', { silentErrors: true });
    }

    async setPatientListRestriction(enabled) {
        return await this.http.put('/admins/settings/patient-list-restriction', { enabled });
    }

    async setFullPatientAccess(clinicianId, enabled) {
        return await this.http.put(`/admins/settings/clinicians/${clinicianId}/full-patient-access`, { enabled });
    }

    /**
     * Which gated sections the signed-in admin may see, and their effective role. Asked on every
     * navigation, so it never toasts: the caller falls back quietly (see SectionAccessContext).
     * A 401 still goes through the usual refresh / sign-out.
     */
    async getVisibleSections() {
        return await this.http.get('/admins/settings/visible-sections', { silentErrors: true });
    }

    /** Every section's audience, with who changed it last. superAdmin only. */
    async getSectionAccess() {
        return await this.http.get('/admins/settings/section-access');
    }

    /**
     * Open a section to every clinician ('all') or limit it to super admins ('superAdmin').
     * `expectedAudience` is what this page shows: if someone changed it since, the server refuses
     * (409) rather than let this page undo their change.
     */
    async setSectionAccess(section, audience, expectedAudience) {
        return await this.http.put('/admins/settings/section-access', { section, audience, expectedAudience });
    }
}

export default new AppSettingsService();
